import { ProfileType, RoleItemType } from '../containers/SignInPage/types'
import moment from 'moment'

type FormatErrorType = {
  response: {
    apiError: {
      errors: string
      message: string
    }
    data: {
      errors: string
    }
  }
}

const { REACT_APP_URL } = process.env

export const checkProfileRole = (
  roles?: RoleItemType[],
  type?: string
): boolean => {
  if (!roles || !type) return false
  return roles.some(role => role.name === type)
}

export const formatErrorMessage = (error: FormatErrorType): string => {
  return (
    (error?.response?.apiError?.errors &&
      Object.values(error?.response?.apiError?.errors).join(', ')) ||
    (error?.response?.data?.errors &&
      Object.values(error?.response?.data?.errors).join(', ')) ||
    error?.response?.apiError?.message ||
    'Что-то пошло не так при отправке данных'
  )
}

export const declOfNum = (number: number, titles: string[]): string => {
  const cases: number[] = [2, 0, 1, 1, 1, 2]
  return titles[
    number % 100 > 4 && number % 100 < 20
      ? 2
      : cases[number % 10 < 5 ? number % 10 : 5]
  ]
}

// DADATA Dots
const SHORT_TYPES = new Set([
  'аобл',
  'респ',
  'вл',
  'г',
  'д',
  'двлд',
  'днп',
  'дор',
  'дп',
  'жт',
  'им',
  'к',
  'кв',
  'км',
  'комн',
  'кп',
  'лпх',
  'м',
  'мкр',
  'наб',
  'нп',
  'обл',
  'оф',
  'п',
  'пгт',
  'пер',
  'пл',
  'платф',
  'рзд',
  'рп',
  'с',
  'сл',
  'снт',
  'ст',
  'стр',
  'тер',
  'туп',
  'ул',
  'х',
  'ш',
])

const addDot = (word: string) => {
  if (SHORT_TYPES.has(word)) {
    return word + '.'
  } else {
    return word
  }
}

export const dadataDots = (address: string) => {
  const parts = address.split(',').map(function (part) {
    const words = part.split(' ').map(addDot)
    return words.join(' ')
  })
  return parts.join(',')
}

export const checkProfileFilled = (profile: ProfileType): boolean => {
  if (profile) {
    const parseName = profile.external_profile.name
    const parseLastName = profile.external_profile.surname
    const parseSex = profile.external_profile.gender
    const parseBirth = profile.external_profile.birthdate
    const parseEdu =
      profile.profile.school?.value &&
      profile.profile.school?.ogrn &&
      profile.profile.school?.city
    const parseAddress =
      profile.external_profile.address?.region &&
      profile.external_profile.address?.location

    return !!(
      parseName &&
      parseLastName &&
      parseSex &&
      parseBirth &&
      parseEdu &&
      parseAddress
    )
  } else {
    return false
  }
}

export const downloadFile = (uri: string, name: string) => {
  fetch(uri, { cache: 'no-cache' })
    .then(response => response.blob())
    .then((blob: Blob) => {
      const url = window.URL.createObjectURL(new Blob([blob]))
      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', name)
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    })
}

export const imgProxy = (path: string, width: number, height: number): string =>
  `${REACT_APP_URL}/imgproxy/s1/fit/${width}/${height}/ce/0/plain/${path}`

export const isDifferentAge = (birthdate: string, age: number): boolean =>
  moment().diff(birthdate, 'years') > age

export const getFormatFromUrl = (url: string): string =>
  url.split(/[#?]/)[0].split('.').pop()?.trim().toLowerCase() || ''
